export default "__VITE_ASSET__waFL75Sv__"